module.exports = __webpack_public_path__ + "resources/img/payment_card.804db69abdce9852241414c8fda0e39a.png";